<template>
  <div>
    <a-modal v-model="visible" :footer="null" centered width="850px" :mask-closable="true" :closable="false" :keyboard="false" @cancel="close('cancel')">
      <template slot="title">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <a-input-group compact style="margin-right: 10px; display: flex; align-items: center">
            <a-select v-model="searchProject" show-search size="large" style="width: 150px" :filter-option="filterOption" @change="changeSearchKeyword">
              <a-select-option :value="0"> 全部项目 </a-select-option>
              <a-select-option v-for="item in projectList" :key="item.id" :value="item.id"> {{ item.name }} </a-select-option>
            </a-select>
            <a-input v-model="searchKeyword" placeholder="搜索契约" size="large" allow-clear @change="changeSearchKeyword">
              <!-- <a-icon slot="prefix" type="search" /> -->
            </a-input>
          </a-input-group>
          <a-button v-tc="{ name: '关联契约' }" size="large" :disabled="selectedApis.length === 0" :loading="loading" @click="onSubmit"> 关联 </a-button>
        </div>
      </template>
      <template slot="footer">
        <a-button v-tc="{ name: '取消' }" @click="close"> 取消 </a-button>
      </template>
      <div>
        <template v-if="searchResult.length > 0">
          <a-card v-for="(item, idx) in searchResult" :key="idx" hoverable size="small" class="api-item-box-card" style="margin-top: 10px">
            <div slot="title">
              <a-checkbox style="margin-right: 10px" :checked="selectedApis.findIndex(api => api.docId === item.id) !== -1" @change="e => toggleSelect(item)" />
              <a-tag color="#108ee9">
                {{ item.projectName }}
              </a-tag>
              <span>
                <a-tag class="name-tag">
                  {{ item.name }}
                </a-tag>
              </span>
            </div>
            <div slot="extra">变更人：<user-profiles :value="[item.updateBy]" avatar /></div>
            <div style="padding-left: 27px">
              <span :style="{ color: methodColor(item.method) }">{{ item.method }}</span> {{ item.path || '' }}
            </div>
          </a-card>
        </template>
        <template v-else>
          <a-empty description="暂无数据" />
        </template>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getNvwaApiVersion, buildVersionList, taskUpdateItem, getNvwaProjectList } from '@/api/project/task';

export default {
  name: 'TaskEdit',
  components: {},
  props: {
    taskId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      searchKeyword: '',
      searchProject: 0,
      searchResult: [],
      selectedApis: [],
      orgVersionList: [],
      projectList: []
    };
  },
  computed: {},
  methods: {
    toggleSelect(api) {
      const index = this.selectedApis.findIndex(item => item.docId === api.id);
      //
      if (index !== -1) {
        this.selectedApis.splice(index, 1);
      } else {
        this.selectedApis.push({ docId: api.id, versionId: api.versionId });
      }
    },
    onOpen(orgVersionList) {
      this.orgVersionList = orgVersionList || [];
      this.visible = true;
      this.getNvwaProjectList();
    },

    getNvwaProjectList() {
      getNvwaProjectList().then(res => {
        if (res && res.result) {
          const plist = res.result || [];
          this.projectList = plist.filter(item => item.id !== 130);
        }
      });
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    changeSearchKeyword() {
      getNvwaApiVersion({ keyword: this.searchKeyword, projectId: this.searchProject })
        .then(res => {
          if (res && res.result && res.result.items) {
            this.searchResult = res.result.items;
          } else {
            this.searchResult = [];
          }
        })
        .catch(() => {})
        .finally(() => {
          this.selectedApis = [];
        });
    },

    /**
     * 模态框关闭回调，如果点击取消，且内容发生变更，则弹窗提示
     * @param {*} type
     */
    close(type = 'submit') {
      // 判断内容是否发生变更
      const self = this;
      self.loading = false;
      self.visible = false;
      self.selectedApis = [];
      self.$emit('close', type);
    },

    methodColor(method) {
      if (method === 'GET') {
        return 'rgb(96,183,146)';
      } else if (method === 'POST') {
        return 'rgb(224,141,73)';
      } else if (method === 'PUT') {
        return 'rgb(81,141,238)';
      } else if (method === 'DELETE') {
        return 'rgb(232,95,51)';
      } else if (method === 'HEAD') {
        return 'rgb(81,141,238)';
      } else if (method === 'OPTIONS') {
        return 'rgb(81,141,238)';
      } else if (method === 'PATCH') {
        return 'rgb(216,68,147)';
      } else {
        return 'rgb(96,183,146)';
      }
    },

    onSubmit() {
      const req = JSON.parse(JSON.stringify(this.selectedApis));
      req.forEach(item => {
        item.taskId = this.taskId;
      });
      buildVersionList(req)
        .then(res => {
          if (res && res.result) {
            // 进行合并去重this.orgVersionList
            const newVersionList = new Set([...this.orgVersionList, ...res.result]);
            const newVersionListArray = Array.from(newVersionList);

            taskUpdateItem({
              task_id: this.taskId,
              key: 'agreements',
              value: newVersionListArray
            }).then(res => {
              this.$message.success('关联契约成功');
              this.close('submit');
            });
          } else {
            this.$message.error('契约校验失败');
          }
        })
        .catch(() => {
          this.$message.error('契约校验失败');
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 8px;

  .ant-form-item-label {
    line-height: 24px;
  }
}

/deep/.ant-modal-body {
  padding: 16px 24px;
  height: 500px;
  overflow-y: auto;

  .ant-spin-text {
    font-size: 16px;
    // color: rgba(0, 0, 0, 0.85);
  }

  .api-item-box-card {
    border-radius: 10px;
  }

  /deep/.ant-card-head {
    min-height: 48px;

    .ant-card-head-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.name-tag {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
</style>
